export class GetFooter {
  static readonly type = '[Footer] - Get footer';

  constructor(public locale: string) {}
}
